// <---- Migration object must be assigned to a variable
const migration1 = {
  version: 1,                // <---- Update version number
  name: "testUpdate",        // <---- Update migration name

  run: async () => {
    /* -------------------------------------------------------
       ADD YOUR UPDATE LOGIC HERE
       <---- Paste your update code inside this function
    ------------------------------------------------------- */

    console.log("Running test update...");
    console.log("✔ Test update complete");
  }
};

// <---- Export the variable instead of anonymous object
export default migration1;
